'use strict';
import React, {findDOMNode} from 'react';
import classnames from 'classnames';
import flux from 'utils/flux';

var Modal = React.createClass({

    closeModal(e) {
        e.preventDefault();
        flux.getActions('modals').closeModals();
    },

    _isNodeInRoot( node, root ) {
        while ( node ) {
            if ( node === root ) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    },

    componentDidMount() {
        document.addEventListener( 'mousedown', this.handleMouseClickOutside );
        document.addEventListener( 'keydown', this.handleKeydown );
    },

    componentWillUnmount() {
        document.removeEventListener( 'mousedown', this.handleMouseClickOutside );
        document.removeEventListener( 'keydown', this.handleKeydown );
    },

    handleMouseClickOutside(e) {
        if ( this._isNodeInRoot( e.target, findDOMNode( this.refs.content ) ) ) {
            return;
        }
        if ( this.props.closeOnOutsideClick ) {
            e.stopPropagation();
            this.closeModal(e);
        }
    },

    handleKeydown(e) {
        if ( this._isNodeInRoot( e.target, findDOMNode( this.refs.content ) ) ) {
            return;
        }
        if ( 27 === e.keyCode ) {
            e.stopPropagation();
            this.closeModal(e);
        }
    },

    renderCloseButton() {
        if ( !this.props.hideCloseButton ) {
            return (
                <a href="#" onClick={this.closeModal} className="modal__close">
                    <i className="close"/>
                </a>
            );
        }
    },

    render: function() {
        return (
            <div className={classnames( 'modal', this.props.className )}>
                <div className="modal__overlay" />
                <div ref="content" className="modal__content">
                    {this.renderCloseButton()}
                    {this.props.children}
                </div>
            </div>
        );
    }
});

module.exports = Modal;



// WEBPACK FOOTER //
// ./app/components/modals/modal.jsx